import { useState } from "react";
import { toast } from "sonner";
import { subscribeNewsletter } from "../lib/api";

// "My Pleasure" lead-magnet strip. Hooked to SendFox List 655738.
// Themed around the audio session "My Pleasure" - listeners join the list
// to be the first to receive the full release + a private preview clip.
export default function NewsletterStrip({ source = "my-pleasure-preview", compact = false }) {
  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const res = await subscribeNewsletter({ email, first_name: firstName || null, source });
      toast.success(res.message || "Check your inbox to confirm.");
      setEmail(""); setFirstName("");
    } catch (err) {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section
      data-testid="newsletter-strip"
      className={`relative ${compact ? "py-16" : "py-24 md:py-32"} grain border-y border-[#c9a04b]/20`}
      style={{
        backgroundImage:
          "linear-gradient(rgba(17,19,25,0.88), rgba(17,19,25,0.94)), url(https://customer-assets.emergentagent.com/job_trance-bookings/artifacts/9y6uucx7_Cleo%20erotic%20hypnosis%20pocket%20watch.jpg)",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="max-w-3xl mx-auto px-6 text-center">
        <div className="eyebrow mb-5">A Gift from Cleopatra</div>
        <h2 className="font-serif text-3xl md:text-5xl text-cream leading-tight mb-5">
          Two guided trances, <em className="text-gold">free</em>.
        </h2>
        <p className="text-cream/70 text-sm md:text-base max-w-xl mx-auto mb-6 leading-relaxed">
          Leave your email and I&rsquo;ll send you two of my private lead-capture recordings.
          Spiral inductions, breathwork, sensory imagery and anchored triggers - delivered by voice.
        </p>

        <div className="grid sm:grid-cols-2 gap-6 max-w-2xl mx-auto mb-10 text-left">
          <div className="border-l-2 border-gold/50 pl-4">
            <div className="text-gold text-sm font-medium mb-1 tracking-wide">My Pleasure</div>
            <div className="text-cream/60 text-[13px] leading-relaxed">
              A slow, sensual evening trance. Pocket-watch pacing, deep breath work, imagery that unspools you into stillness.
            </div>
          </div>
          <div className="border-l-2 border-gold/50 pl-4">
            <div className="text-gold text-sm font-medium mb-1 tracking-wide">Remember Me</div>
            <div className="text-cream/60 text-[13px] leading-relaxed">
              A short anchoring recording. Plants a gentle post-trance trigger so my voice can find you whenever you need it.
            </div>
          </div>
        </div>

        <p className="text-cream/45 text-xs uppercase tracking-[0.2em] mb-8">Double opt-in &middot; unsubscribe anytime</p>

        <form onSubmit={onSubmit} className="flex flex-col md:flex-row gap-3 max-w-2xl mx-auto" data-testid="newsletter-form">
          <input
            type="text"
            placeholder="First name (optional)"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            data-testid="newsletter-firstname"
            className="bg-transparent border border-[#c9a04b]/35 text-cream placeholder:text-cream/40 px-4 py-3.5 text-sm flex-1 focus:outline-none focus:border-gold"
          />
          <input
            type="email"
            required
            placeholder="Your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            data-testid="newsletter-email"
            className="bg-transparent border border-[#c9a04b]/35 text-cream placeholder:text-cream/40 px-4 py-3.5 text-sm flex-1 focus:outline-none focus:border-gold"
          />
          <button
            type="submit"
            disabled={loading}
            data-testid="newsletter-submit"
            className="btn-primary"
          >
            {loading ? "Sending…" : "Send Me Both"}
          </button>
        </form>
        <p className="text-[11px] text-cream/40 mt-5 tracking-wider">By subscribing you confirm you are 18+ and accept our Privacy Policy.</p>
      </div>
    </section>
  );
}
